import { Mapper } from "../../../../base/utils/mapper";
import { CategoryAcademyModel } from "../../../../domain/models/academy/category-academy.model";
import { CategoryAcademyEntity } from "../entities/category-academy.entity";


export class CategoryacademyImplementationRepositoryMapper
extends Mapper<
CategoryAcademyEntity,
CategoryAcademyModel
> {

    mapFrom(param:
    CategoryAcademyEntity):
    CategoryAcademyModel {

        return {
            ...param
        };
    }

    mapTo(param:
    CategoryAcademyModel):
    CategoryAcademyEntity {

        return {
            ...param
        };
    }
}